<ng-container *transloco="let t">
  @if (type === 'icon') {
    <!-- Icon Button -->
    <button mat-icon-button [matMenuTriggerFor]="buttonMenu" [class]="class" [color]="color" [disabled]="disabled">
      <div class="flex justify-center items-center">
        @if (icon) {
          <mat-icon class="icon-size-5" [svgIcon]="icon"></mat-icon>
        }
      </div>
    </button>
  } @else {
    <button
      mat-flat-button
      [matMenuTriggerFor]="buttonMenu"
      [class]="class"
      [color]="color"
      [disabled]="disabled"
      [ngClass]="{
        'mat-mdc-button mat-mdc-button': type === 'basic',
        'mat-mdc-button mat-mdc-raised-button': type === 'raised',
        'mdc-button--outlined mat-mdc-outlined-button': type === 'stroked',
        'mat-mdc-unelevated-button': type === 'flat',
        'mdc-fab mat-mdc-fab': type === 'fab',
        'mdc-fab mdc-fab--mini mat-mdc-mini-fab': type === 'mini-fab',
      }"
    >
      <div class="flex justify-center items-center">
        @if (icon) {
          <mat-icon class="icon-size-5" [svgIcon]="icon"></mat-icon>
        }
        <span [ngClass]="{ 'hidden sm:block sm:ml-1': icon }">
          {{ t(label) | capitalize }}
        </span>
        @if (trailingIcon) {
          <mat-icon class="icon-size-5 ml-1 -mr-1" [svgIcon]="trailingIcon"></mat-icon>
        }
      </div>
    </button>
  }

  <mat-menu #buttonMenu="matMenu">
    @for (action of actions; track action; let index = $index) {
      @if (!action?.hide) {
        <button
          mat-menu-item
          [class]="action?.class"
          [attr.data-testid]="action?.testId"
          (click)="doOptionClick(action?.method, index, action)"
        >
          @if (action?.bulletClass) {
            <span class="w-2.5 h-2.5 mr-2 rounded-full shrink-0" [class]="action?.bulletClass"></span>
          }
          @if (action?.icon) {
            <mat-icon class="icon-size-6 p-0 m-0 pr-2" [svgIcon]="action?.icon"></mat-icon>
          }
          <ng-container *transloco="let t">
            {{ (action?.translate ? t(action?.label ?? '') : action?.label) | capitalize }}
          </ng-container>
        </button>
      }
    }
  </mat-menu>
</ng-container>
